import React from 'react';
import Formsy from 'formsy-react';
import { gql, graphql } from 'react-apollo';
import { Button } from 'elements';
import Select from 'elements/Form/Select';
import TextArea from 'elements/Form/Input/TextArea';
import { Flex } from 'core/layout';
import { StyledFeedback, StyledFilter, FilterLabel } from './styled';
import tulkojumi from 'utils/tulkojumi';


class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.disableButton = this.disableButton.bind(this);
    this.enableButton = this.enableButton.bind(this);
    this._submit = this._submit.bind(this);
    this._filterSelect = this._filterSelect.bind(this);

    const { teksti } = this.props
    this.selects = [

      {
        id: 'raksts_nav_pareizs',
        label: tulkojumi(teksti, 'raksts_nav_pareizs')
      },
      {
        id: 'raksts_nav_saprotams',
        label: tulkojumi(teksti, 'raksts_nav_saprotams')
      },
      {
        id: 'man_nepatik_informacija',
        label: tulkojumi(teksti, 'man_nepatik_informacija')
      }, {
        id: 'cits',
        label: tulkojumi(teksti, 'cits')
      }
    ]

    this.state = { feedback: 0, extraForm: 0, canSubmit: false, selected_iemesls: [] };
  }


  disableButton() {
    this.setState(prevState => Object.assign({}, prevState, {
      canSubmit: false
    }))
  }

  enableButton() {
    this.setState(prevState => Object.assign({}, prevState, {
      canSubmit: true
    }))
  }

  _submit(data, resetForm, invalidateForm) {
    const { lang, path, mutate } = this.props

    window.gtag && gtag('event', this.state.selected_iemesls, {
      event_category: 'feedback',
      event_label: 'iemesls'
    });

    mutate({
      variables: { lang: lang, path: path, informacija_noderiga: 0, iemesls: 'cits', komentars: data.zina }
    })
      .then(res => {
        this.setState(prevState => Object.assign({}, prevState, {
          feedback: 1,
          extraForm: 0
        }))
      })
  }


  _sendFeedback(event, informacija_noderiga) {
    event.preventDefault()

    const { lang, path, mutate } = this.props

    if (informacija_noderiga) {

      let iemesls = ''
      let komentars = ''

      window.gtag && gtag('event', informacija_noderiga, {
        event_category: 'feedback',
        event_label: 'informacija_noderiga'
      });

      mutate({
        variables: { lang: lang, path: path, informacija_noderiga: informacija_noderiga, iemesls: iemesls, komentars: komentars }
      })
        .then(res => {
          this.setState(prevState => Object.assign({}, prevState, {
            feedback: 1
          }))
        })
    } else {
      this.setState(prevState => Object.assign({}, prevState, {
        extraForm: 1
      }))
    }
  }

  _filterSelect(event, iemesls, selected, multiselect) {
    event.preventDefault()

    let ID = this.state.selected_iemesls
    let index = this.state.selected_iemesls.indexOf(iemesls)
    if (!multiselect) {
      ID = [iemesls]
    } else {
      if (index === -1) {
        ID.push(iemesls)
      } else {
        ID.splice(index, 1)
      }
    }

    if (iemesls === 'cits') {
      this.setState(prevState => Object.assign({}, prevState, {
        selected_iemesls: ID
      }))
    } else {
      const { lang, path, mutate } = this.props

      // let iemesls = this.state.selected_iemesls
      let komentars = ''

      mutate({
        variables: { lang: lang, path: path, informacija_noderiga: 0, iemesls: iemesls, komentars: komentars }
      })
        .then(res => {
          this.setState(prevState => Object.assign({}, prevState, {
            feedback: 1,
            extraForm: 0
          }))
        })

    }
  }

  render() {
    const { teksti } = this.props
    const filteredData = this.state.selected_iemesls

    return (
      <StyledFeedback>

        {
          !this.state.feedback && !this.state.extraForm ? (
            <div>
              {tulkojumi(teksti, 'vai_si_informacija_bija_noderiga')}
              <nobr>
                <Button
                  type='text'
                  label={tulkojumi(teksti, 'ja')}
                  a11yLabel={tulkojumi(teksti, 'ja_informacija_bija_noderiga')}
                  onClick={(event) => this._sendFeedback(event, 1)}
                />
                {tulkojumi(teksti, 'vai')}
                <Button
                  type='text'
                  label={tulkojumi(teksti, 'ne')}
                  a11yLabel={tulkojumi(teksti, 'ne_informacija_nebija_noderiga')}
                  onClick={(event) => this._sendFeedback(event, 0)}
                />
              </nobr>
            </div>
          ) :

            !this.state.extraForm ?
              (<div>
                {tulkojumi(teksti, 'paldies_zina_sanemta')}
              </div>)
              : (
                  <Formsy onValidSubmit={this._submit} onValid={this.enableButton} onInvalid={this.disableButton}>

                    <StyledFilter>
                      <FilterLabel>
                        {tulkojumi(teksti, 'ka_uzlabot_rakstu')}
                      </FilterLabel>
                      <Select
                        multiselect={false}
                        placeholder={tulkojumi(teksti, 'izvelaties_iemeslu')}
                        options={this.selects && this.selects.map(select => ({
                          id: select.id,
                          label: select.label,
                          selected: filteredData && filteredData.indexOf(select.id) > -1,
                        }))}
                        onChange={(id, selected) => {
                          this._filterSelect(event, id, selected, false);
                        }}
                      />
                    </StyledFilter>

                    {this.selects && this.selects.map(select => filteredData && filteredData.indexOf(select.id) > -1 ? <input key={select.id} name='ka_uzlabot_rakstu' id='ka_uzlabot_rakstu' type='hidden' value={select.id} /> : null)}

                    {filteredData && filteredData.indexOf('cits') > -1 ? <div>
                      <input type='hidden' name='iemesls' value={filteredData} />
                      <TextArea
                        placeholder={tulkojumi(teksti, 'tava_zina')}
                        aria-label={tulkojumi(teksti, 'tava_zina')}
                        name="zina"
                        validations="minLength:7"
                        validationError={tulkojumi(teksti, 'noradiet_precizu_informaciju')}
                        required
                      />
                      <p>
                        <Button a11yLabel={tulkojumi(teksti, 'nosutit')} type='outlined' typeAttr='submit' disabled={!this.state.canSubmit} >{tulkojumi(teksti, 'nosutit')}{!this.state.canSubmit}</Button>
                      </p>

                    </div> : null}
                  </Formsy>)
        }

      </StyledFeedback>
              );
        }
}

const addFeedbackMutation = gql`
  mutation submitFeedback($lang: String!, $informacija_noderiga: Int!, $path: String, $iemesls: String, $komentars: String) {
          submitFeedback(lang: $lang, path: $path, informacija_noderiga: $informacija_noderiga, iemesls: $iemesls, komentars: $komentars) {
          path
      informacija_noderiga
        iemesls
      komentars
    }
  }
`;

export default graphql(
  addFeedbackMutation
)(Feedback);



// WEBPACK FOOTER //
// ./src/modules/Feedback/Feedback.jsx